import { useCallback, useEffect, useState } from 'react'

import { discoveryApi } from '../api'
import type { Category } from '../types'

type CategoriesPhase = 'loading' | 'ready' | 'error'

export function useCategories(): {
  categories: Category[]
  phase: CategoriesPhase
  error: unknown
  retry: () => void
} {
  const [categories, setCategories] = useState<Category[]>([])
  const [phase, setPhase] = useState<CategoriesPhase>('loading')
  const [error, setError] = useState<unknown>(null)
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    const controller = new AbortController()
    discoveryApi
      .listCategories(controller.signal)
      .then((items) => {
        setCategories(items)
        setPhase('ready')
        setError(null)
      })
      .catch((cause: unknown) => {
        if (controller.signal.aborted) return
        setError(cause)
        setPhase('error')
      })
    return () => controller.abort()
  }, [attempt])

  const retry = useCallback(() => {
    setError(null)
    setPhase('loading')
    setAttempt((value) => value + 1)
  }, [])

  return { categories, phase, error, retry }
}
